module.exports = "/_next/static/images/598e5a1228e5cd54731c2f57f32dec58-secured-icon-lg.svg.webp";